module.exports = __webpack_public_path__ + "img/MercenaryForceTitleScreen.0ea6e02e.png";